import styled from 'styled-components';

export const MainContentWrapper = styled.div`
  width: ${props => (props.isSubMenuOpen ? 'calc(100% - 120px)' : '100%')};
  margin-left: ${props => (props.isSubMenuOpen ? '150px' : '120px')};
`;
